import React, { PureComponent } from 'react'
import { Button, TableRow, TableCell, MenuItem } from '@material-ui/core'

// utils
import { hasAccess } from '../../utils/api'

import { EditableReactSelect, EditableSelect } from '../common/EditableComponents'
import EditActionComponent from '../common/EditActionComponent'

export default class OnFleetEmployeeItem extends PureComponent {
  state = {
    isNew: true,
    currentTeamId: '',
    teamDropDownChange: false,
    workers: [],
    currentWorkersId: null,
  }

  extractShopAndTeam = (value) => {
    const splittedValue = value.split('BLAZE')

    const shopId = splittedValue[0]
    const teamId = splittedValue[1]

    return {
      shopId,
      teamId,
    }
  }

  linkWorker = () => {
    const { data = {} } = this.props
    const { shopId, teamId } = this.extractShopAndTeam(this.state.currentTeamId)
    this.props.linkWorker(data.id, shopId, this.state.currentWorkersId, teamId, () =>
      this.props.disableEdit(),
    )
  }

  removeWorker = () => {
    const { data = {} } = this.props

    const { employeeOnFleetInfoResults = [], id } = data

    const { selectedOnfleet } = this.filterSelectedTeam(employeeOnFleetInfoResults)

    const { shopId, teamId } = this.extractShopAndTeam(selectedOnfleet.value)

    this.props.removeWorker(id, shopId, teamId, () => this.props.disableEdit())
    this.setState({ teamDropDownChange: false })
  }

  onSave = () => {
    this.props.onSave((response) => this.props.disableEdit())
    this.setState({ teamDropDownChange: false })
    this.changeWorkersId(null)
  }

  onCancel = () => {
    this.props.onCancel()
    this.setState({ teamDropDownChange: false })
    this.changeWorkersId(null)
  }

  filterSelectedWorker = (employeeOnFleetInfoResults) => {
    const onFleetEmployeeTeam = employeeOnFleetInfoResults || []
    let selectedWorker = []
    onFleetEmployeeTeam.forEach((info) => {
      if (info.onFleetWorkerId) {
        selectedWorker.push({
          value: info.onFleetWorkerId,
          label: info.onFleetWorkerName,
        })
      }
    })
    return selectedWorker
  }

  filterSelectedTeam = (employeeOnFleetInfoResults) => {
    const onFleetEmployeeTeam = employeeOnFleetInfoResults || []

    let selectedTeam = []
    let selectedOnfleet = {}

    onFleetEmployeeTeam.forEach((team) => {
      if (team.onFleetWorkerId && team.onFleetTeamList[0]) {
        // if onfleetworkid exist set isNew to false
        if (this.state.isNew) {
          this.setState({
            isNew: false,
          })
        }

        selectedTeam.push(team.shopName + ':' + team.onFleetWorkerId)
      }

      if (team.employeeOnFleetTeams && team.onFleetTeamList[0]) {
        selectedOnfleet = {
          value: `${team.shopId}BLAZE${team.onFleetTeamList[0]}`,
          label: `${team.shopName} | ${team.employeeOnFleetTeams[team.onFleetTeamList[0]]}`,
        }
        if (!this.state.teamDropDownChange) this.setState({ currentTeamId: selectedOnfleet.value })
      }
    })

    return {
      selectedTeam,
      selectedOnfleet,
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { data } = nextProps

    if (
      (!data.employeeOnFleetInfoResults || !data.employeeOnFleetInfoResults.length) &&
      !prevState.isNew
    ) {
      return {
        isNew: true,
      }
    }

    return null
  }

  onEdit = (selectedOnfleet) => {
    if (selectedOnfleet.value) {
      const { shopId, teamId } = this.extractShopAndTeam(selectedOnfleet.value)
      this.props.getWorkers(teamId, shopId, (workers) => this.setState({ workers }))
    }
    this.props.enableEdit()
  }

  onChange = (e) => {
    const { value = '' } = e.target

    const { shopId, teamId } = this.extractShopAndTeam(value)
    this.changeTeamId(value)
    this.props.getWorkers(teamId, shopId, (workers) => this.setState({ workers }))
  }
  changeTeamId = (value) => {
    this.setState({ currentTeamId: value, teamDropDownChange: true })
  }

  changeWorkersId = (value) => {
    this.setState({ currentWorkersId: value })
  }

  onChangeWorkers = (workers) => {
    const { data = {} } = this.props
    const workerIds = workers.map((w) => w.value)
    const { shopId, teamId } = this.extractShopAndTeam(this.state.currentTeamId)
    if (workers.find((w) => w.value === 'addWorker')) {
      this.props.createNewWorker(data.id, shopId, teamId, (res) => {
        if (res.onFleetWorkerId) {
          workerIds[workerIds.length - 1] = res.onFleetWorkerId
          this.changeWorkersId(workerIds)
          this.props.getWorkers(teamId, shopId, (workers) => this.setState({ workers }))
        }
      })
      return
    }
    this.changeWorkersId(workerIds)
  }

  render() {
    const { data, editMode, teamList } = this.props

    const { employeeOnFleetInfoResults = [] } = data

    const { selectedOnfleet } = this.filterSelectedTeam(employeeOnFleetInfoResults)

    const selectedWorkers = this.filterSelectedWorker(employeeOnFleetInfoResults)

    const selectedWorkersWithData = this.state.workers.filter((worker) =>
      selectedWorkers.find((w) => w.value === worker.id),
    )

    let workersOptions = this.state.workers.map((worker) => ({
      label: worker.name,
      value: worker.id,
    }))

    workersOptions.unshift({ label: '[Add Worker]', value: 'addWorker' })

    const { isNew } = this.state

    const showRemoveButton = editMode && !isNew

    return (
      <TableRow>
        <TableCell className="cell-wrap-word">{`${data.firstName} ${data.lastName}`}</TableCell>
        <TableCell className="cell-wrap-word">
          <EditableSelect
            value={this.state.currentTeamId}
            onChange={this.onChange}
            valueToRender={selectedOnfleet.label}
            editMode={editMode}
          >
            {teamList.map((item, index) => {
              return (
                <MenuItem key={index} value={item.value}>
                  {item.label}
                </MenuItem>
              )
            })}
          </EditableSelect>
        </TableCell>
        <TableCell className="cell-wrap-word multi-select-position">
          <EditableReactSelect
            multi={true}
            valueToRender={selectedWorkers.map((worker) => worker.label || worker.value).join(', ')}
            editMode={editMode}
            value={
              this.state.currentWorkersId || selectedWorkersWithData.map((worker) => worker.id)
            }
            onChange={this.onChangeWorkers}
            type="text"
            InputLabelProps={{
              shrink: true,
            }}
            options={workersOptions}
          />
        </TableCell>
        {hasAccess() ? (
          <TableCell className="cell-wrap-word">
            <EditActionComponent
              onSave={this.linkWorker}
              onCancel={this.onCancel}
              onEdit={this.onEdit.bind(this, selectedOnfleet)}
              editMode={editMode}
              editTitle={isNew ? 'Link' : 'Update'}
            />
            {showRemoveButton ? (
              <Button className="danger-button" onClick={this.removeWorker}>
                Remove Team
              </Button>
            ) : null}
          </TableCell>
        ) : null}
      </TableRow>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/OnFleet/OnFleetEmployeeItem.js